























import { Component, Vue } from "vue-property-decorator";
import AuthorIcon from "@/components/AuthorIcon.vue";
import { User } from "@/components/data-types/User.ts";

@Component({
  components: {
    AuthorIcon
  }
})
export default class VideoLinks extends Vue {
  data() {
    return {
      youtube: [{ author: "DerpIslands", channel: "UClQ-BYe1Z7KPHZRgYHozQVA" }],
      twitch: [{ author: "DerpIslands", channel: "derpislands" }]
    };
  }
  created() {
    fetch("/json-data/video-channels.json")
      .then(r => r.json())
      .then(users =>
        users.forEach((user: User) => {
          if (user.youtube) {
            this.$data.youtube.push({
              author: user.username,
              channel: user.youtube
            });
          }
          if (user.twitch) {
            this.$data.twitch.push({
              author: user.username,
              channel: user.twitch
            });
          }
        })
      );
  }
}
